'use client'

import { motion, useReducedMotion } from 'motion/react'
import Image from 'next/image'
import { LANDING_IMAGE_BASE } from './landing-content'

/**
 * Decorative dithered Brew mark beneath the closing CTA (carried over from
 * jason's footer CTA). Fades and rises into view; static under reduced
 * motion. `dark:invert` keeps the dark-on-transparent dot art legible on
 * the near-black dark canvas. A radial-gradient mask fades the illustration
 * out toward its edges (mirrors jason's radial fade on the bottom mark) so
 * the dot art melts into the canvas instead of ending on a hard circle.
 */
const RADIAL_FADE_MASK =
  'radial-gradient(circle at 50% 50%, #000 48%, transparent 78%)'

export function ClosingCtaLogo() {
  const shouldReduceMotion = useReducedMotion()

  return (
    <motion.div
      aria-hidden="true"
      className="pointer-events-none mt-4 flex w-full max-w-md justify-center opacity-80"
      initial={shouldReduceMotion ? false : { opacity: 0, y: 24, scale: 0.96 }}
      whileInView={
        shouldReduceMotion ? undefined : { opacity: 0.8, y: 0, scale: 1 }
      }
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <Image
        src={`${LANDING_IMAGE_BASE}/cta-image.png`}
        alt=""
        width={2038}
        height={2032}
        sizes="(max-width: 768px) 70vw, 448px"
        className="h-auto w-full dark:invert"
        style={{
          WebkitMaskImage: RADIAL_FADE_MASK,
          maskImage: RADIAL_FADE_MASK,
        }}
      />
    </motion.div>
  )
}
